import React from "react";

/**
 * Lightweight placeholder for mobile-only screens that are yet to be ported to web.
 * Shows the mobile screen name and a short note so QA/design can track progress.
 */
const PendingScreen = ({ title, mobileScreen, note }) => {
  const bg = "linear-gradient(135deg, #0d2f4f 0%, #0b5fa5 100%)";
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: bg,
        color: "#f5f7fb",
        padding: "32px",
      }}
    >
      <div
        style={{
          maxWidth: 760,
          width: "100%",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.12)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
          borderRadius: 16,
          padding: "28px",
          backdropFilter: "blur(4px)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: "rgba(255,255,255,0.14)",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              letterSpacing: "0.02em",
            }}
          >
            {title?.[0] || "?"}
          </div>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700 }}>{title || "Coming soon"}</div>
            {mobileScreen ? (
              <div style={{ opacity: 0.78, marginTop: 4, fontSize: 14 }}>
                Mobile ref: <strong>{mobileScreen}</strong>
              </div>
            ) : null}
          </div>
        </div>

        <div style={{ marginTop: 20, lineHeight: 1.6, opacity: 0.92 }}>
          This screen is queued for web parity. If you have API contracts, UX notes, or
          business rules for this flow, share them and we’ll wire it up next.
        </div>
        {note ? (
          <div
            style={{
              marginTop: 18,
              padding: "12px 14px",
              borderRadius: 12,
              background: "rgba(255,255,255,0.08)",
              fontSize: 14,
              opacity: 0.95,
            }}
          >
            {note}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PendingScreen;
